export function getUrlParameter(sParam: string): string | true {
    const sPageURL = decodeURIComponent(window.location.search.substring(1));
    const sURLVariables = sPageURL.split("&");
    let sParameterNameValue: string[];
    let sParameterName: string | true;

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < sURLVariables.length; i++) {
        sParameterNameValue = sURLVariables[i].split("=");

        if (sParameterNameValue[0] === sParam) {
            if (sParameterNameValue[1] === undefined) {
                sParameterName = true;
            } else {
                sParameterName = sParameterNameValue[1];
            }
        }
    }

    return sParameterName;
}
